(() => {
  'use strict';

  const ROOT_SELECTOR =
    '[data-mooa-product-recommendations]';

  const CARD_SELECTOR =
    '[data-mooa-product-recommendation]';

  const CART_ENDPOINT =
    `${window.Shopify?.routes?.root || '/'}cart.js`;

  const MAX_PROMOTED = 1;

  let cartProductIds = new Set();


  /* =========================================================
     UTILIDADES
     ========================================================= */

  function shuffle(items) {
    const result = [...items];

    for (
      let i = result.length - 1;
      i > 0;
      i -= 1
    ) {
      const j = Math.floor(
        Math.random() * (i + 1)
      );

      [
        result[i],
        result[j]
      ] = [
        result[j],
        result[i]
      ];
    }

    return result;
  }


  function uniqueByProduct(cards) {
    const seen = new Set();

    return cards.filter((card) => {
      const id =
        String(
          card.dataset.productId || ''
        );

      if (
        !id ||
        seen.has(id)
      ) {
        return false;
      }

      seen.add(id);

      return true;
    });
  }


  function getValidCandidates(
    cards,
    selectedIds
  ) {

    return uniqueByProduct(cards)
      .filter((card) => {

        const id =
          String(
            card.dataset.productId || ''
          );

        return (
          id &&
          !selectedIds.has(id) &&
          !cartProductIds.has(id)
        );

      });

  }


  /* =========================================================
     CARRITO ACTUAL
     ========================================================= */

  async function refreshCartProductIds() {
    try {

      const response =
        await fetch(
          CART_ENDPOINT,
          {
            credentials: 'same-origin',

            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {
        return;
      }


      const cart =
        await response.json();


      cartProductIds =
        new Set(
          (cart.items || [])
            .map((item) =>
              String(item.product_id)
            )
        );


    } catch (error) {

      console.warn(
        '[MööA] No se pudo leer el carrito:',
        error
      );

    }
  }


  /* =========================================================
     REFRESCAR CARRITO PRESTIGE
     ========================================================= */

  function refreshPrestigeCart() {

    document.documentElement.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles: true
        }
      )
    );

  }


  /* =========================================================
     ABRIR CARRITO PRESTIGE
     ========================================================= */

  function openPrestigeCart() {

    window.setTimeout(
      () => {

        const cartDrawer =
          document.getElementById(
            'cart-drawer'
          );


        if (
          cartDrawer &&
          typeof cartDrawer.show === 'function'
        ) {

          cartDrawer.show();

        }

      },
      150
    );

  }


  /* =========================================================
     AÑADIR CANDIDATO
     ========================================================= */

  function addCandidate(
    card,
    selected,
    selectedIds,
    selectedFamilies,
    maxProducts
  ) {

    if (
      !card ||
      selected.length >= maxProducts
    ) {
      return false;
    }


    const id =
      String(
        card.dataset.productId || ''
      );


    if (
      !id ||
      selectedIds.has(id) ||
      cartProductIds.has(id)
    ) {
      return false;
    }


    selected.push(card);

    selectedIds.add(id);


    const family =
      card.dataset.family || '';


    if (family) {
      selectedFamilies.add(family);
    }


    return true;
  }


  /* =========================================================
     SELECCIÓN SIN REPETIR FAMILIA
     ========================================================= */

  function chooseDistinctFamilies(
    candidates,
    selected,
    selectedIds,
    selectedFamilies,
    currentFamily,
    maxProducts
  ) {

    const available =
      shuffle(
        getValidCandidates(
          candidates,
          selectedIds
        )
      );


    /*
     * PRIMERA PASADA
     *
     * Familia:
     * - diferente del producto actual
     * - todavía no utilizada
     */

    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      const family =
        card.dataset.family || '';


      if (
        !family ||
        family === currentFamily ||
        selectedFamilies.has(family)
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });


    /*
     * SEGUNDA PASADA
     *
     * Permitimos la misma familia que
     * el producto actual, pero seguimos
     * sin repetir familias entre
     * recomendaciones.
     */

    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      const family =
        card.dataset.family || '';


      if (
        !family ||
        selectedFamilies.has(family)
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });

  }


  /* =========================================================
     ÚLTIMO RECURSO
     PERMITIR REPETIR FAMILIA
     ========================================================= */

  function fillRemaining(
    candidates,
    selected,
    selectedIds,
    selectedFamilies,
    maxProducts
  ) {

    const available =
      shuffle(
        getValidCandidates(
          candidates,
          selectedIds
        )
      );


    available.forEach((card) => {

      if (
        selected.length >= maxProducts
      ) {
        return;
      }


      addCandidate(
        card,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    });

  }


  /* =========================================================
     INICIALIZACIÓN DE RECOMENDACIONES
     ========================================================= */

  function initialiseRecommendations(
    root
  ) {

    if (
      !(root instanceof HTMLElement)
    ) {
      return;
    }


    const allCards =
      Array.from(
        root.querySelectorAll(
          CARD_SELECTOR
        )
      );


    /*
     * Ocultamos inicialmente todas.
     */

    allCards.forEach((card) => {
      card.hidden = true;
    });


    const maxProducts =
      Math.max(
        1,
        Number(
          root.dataset.maxProducts || 3
        )
      );


    const currentFamily =
      root.dataset.currentFamily || '';


    const currentProductId =
      String(
        root.dataset
          .currentProductId || ''
      );


    const selected = [];

    const selectedIds =
      new Set([
        currentProductId
      ]);

    const selectedFamilies =
      new Set();


    /* =====================================================
       CANDIDATOS POR PRIORIDAD
       ===================================================== */

    const promoted =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 0
      );


    const manual =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 1
      );


    const history =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 2
      );


    const collection =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 3
      );


    const catalog =
      allCards.filter(
        (card) =>
          Number(
            card.dataset.priority
          ) === 4
      );


    /* =====================================================
       PRIORIDAD 0 — PROMOCIÓN
       ===================================================== */

    const availablePromoted =
      shuffle(
        getValidCandidates(
          promoted,
          selectedIds
        )
      );


    availablePromoted
      .slice(
        0,
        MAX_PROMOTED
      )
      .forEach((card) => {

        addCandidate(
          card,
          selected,
          selectedIds,
          selectedFamilies,
          maxProducts
        );

      });


    /* =====================================================
       PRIORIDAD 1 — COMPLEMENTA CON
       ===================================================== */

    chooseDistinctFamilies(
      manual,
      selected,
      selectedIds,
      selectedFamilies,
      currentFamily,
      maxProducts
    );


    /* =====================================================
       PRIORIDAD 2 — HISTORIA
       ===================================================== */

    if (
      selected.length <
      maxProducts
    ) {

      chooseDistinctFamilies(
        history,
        selected,
        selectedIds,
        selectedFamilies,
        currentFamily,
        maxProducts
      );

    }


    /* =====================================================
       PRIORIDAD 3 — COLECCIÓN
       ===================================================== */

    if (
      selected.length <
      maxProducts
    ) {

      chooseDistinctFamilies(
        collection,
        selected,
        selectedIds,
        selectedFamilies,
        currentFamily,
        maxProducts
      );

    }


    /* =====================================================
       PRIORIDAD 4 — CATALOGO
       ===================================================== */

    if (
      selected.length <
      maxProducts
    ) {

      chooseDistinctFamilies(
        catalog,
        selected,
        selectedIds,
        selectedFamilies,
        currentFamily,
        maxProducts
      );

    }


    /* =====================================================
       SEGUNDA FASE — PERMITIR REPETIR FAMILIA
       ===================================================== */

    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        manual,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        history,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        collection,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    if (
      selected.length <
      maxProducts
    ) {

      fillRemaining(
        catalog,
        selected,
        selectedIds,
        selectedFamilies,
        maxProducts
      );

    }


    /* =====================================================
       MOSTRAR SELECCIÓN
       ===================================================== */

    selected.forEach((card) => {
      card.hidden = false;
    });


    root.hidden =
      selected.length === 0;

  }


  function initialiseAllRecommendations() {

    document
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initialiseRecommendations
      );

  }


  /* =========================================================
     AÑADIR AL CARRITO
     ========================================================= */

  async function addVariant(
    button
  ) {

    const card =
      button.closest(
        CARD_SELECTOR
      );


    if (!card) {
      return;
    }


    const selector =
      card.querySelector(
        '[data-mooa-rec-variant]'
      );


    const variantId =
      button.dataset.variantId ||
      selector?.value ||
      '';


    if (!variantId) {
      return;
    }


    const productId =
      String(
        card.dataset.productId || ''
      );


    const originalText =
      button.textContent.trim();


    button.disabled = true;

    button.textContent =
      'Añadiendo…';


    document.dispatchEvent(
      new CustomEvent(
        'theme:loading:start'
      )
    );


    try {

      const response =
        await fetch(
          (
            window.routes
              ?.cartAddUrl ||
            '/cart/add'
          ) + '.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                items: [
                  {
                    id:
                      Number(
                        variantId
                      ),

                    quantity: 1
                  }
                ]
              })
          }
        );


      document.dispatchEvent(
        new CustomEvent(
          'theme:loading:end'
        )
      );


      if (!response.ok) {

        const error =
          await response
            .json()
            .catch(
              () => ({})
            );


        throw new Error(
          error.description ||
          'No se pudo añadir'
        );

      }


      /*
       * Registramos inmediatamente
       * el producto en carrito.
       */

      if (productId) {

        cartProductIds.add(
          productId
        );

      }


      button.textContent =
        'Añadido ✓';


      /* =====================================================
         ACTUALIZAR Y ABRIR CARRITO
         ===================================================== */

      refreshPrestigeCart();

      openPrestigeCart();


      /* =====================================================
         RECALCULAR RECOMENDACIONES DE LA FICHA
         ===================================================== */

      window.setTimeout(
        () => {

          initialiseAllRecommendations();

        },
        120
      );


      window.setTimeout(
        () => {

          if (
            !document.body
              .contains(button)
          ) {
            return;
          }


          button.disabled =
            false;

          button.textContent =
            originalText;

        },
        1200
      );


    } catch (error) {


      document.dispatchEvent(
        new CustomEvent(
          'theme:loading:end'
        )
      );


      button.textContent =
        /stock|sold|available/i
          .test(
            error.message
          )
          ? 'Sin stock'
          : 'Reintentar';


      window.setTimeout(
        () => {

          if (
            !document.body
              .contains(button)
          ) {
            return;
          }


          button.disabled =
            false;

          button.textContent =
            originalText;

        },
        1800
      );

    }

  }


  /* =========================================================
     EVENTOS
     ========================================================= */

  function handleClick(
    event
  ) {

    const button =
      event.target.closest(
        '[data-mooa-rec-add]'
      );


    if (!button) {
      return;
    }


    event.preventDefault();


    addVariant(
      button
    );

  }


  /*
   * Cuando el carrito cambia desde otro
   * punto de la tienda:
   *
   * 1. Leemos de nuevo /cart.js
   * 2. Actualizamos cartProductIds
   * 3. Recalculamos "Más MööA para ti"
   */

  async function handleCartChanged() {

    await refreshCartProductIds();

    initialiseAllRecommendations();

  }


  /* =========================================================
     START
     ========================================================= */

  async function start() {

    /*
     * Antes de mostrar recomendaciones,
     * leemos qué productos están ya
     * en el carrito.
     */

    await refreshCartProductIds();


    initialiseAllRecommendations();


    document.addEventListener(
      'click',
      handleClick
    );


    /*
     * Añadidos mediante los mecanismos
     * nativos de Prestige.
     */

    document.addEventListener(
      'product:added',
      handleCartChanged
    );


    /*
     * Refrescos del Cart Drawer.
     *
     * Este es el evento importante para
     * sincronizar la ficha cuando añadimos
     * desde "Completa tu look".
     */

    document.documentElement.addEventListener(
      'cart:refresh',
      handleCartChanged
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }

})();